module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/warning-422b1785fda178f8c553ec9d38ad9daa.svg";